import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";
import { PaymentInterface } from "../../Entity/Entities/Payment/PaymentInterface";

class PaymentUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const payment: PaymentInterface = PaymentFactory.create(props.res);

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_UPDATE_SUCCESS,
      payload: {
        payment: payment
      }
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })
  }
}

export { PaymentUpdate };
